import { useIntl } from 'react-intl';
import moment from 'moment';
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Container, Paper, Divider } from "@mui/material";
import {
    Select,
    Button,
} from '@gpstrackit/react-controls';

//Components
import DataView from 'Components/DataView';
import CustomSelect from 'Components/Select';

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './main.scss';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Actions
import {
    clearRedux,
    activitiesSearchActivitiesLogsRequest,
    activitiesSearchUsersRequest,
} from "Redux/actions";

import { getAccounts } from './redux/saga'

//Helpers
import { getTimeFrame, getAuditLogsActions } from 'Utils/helpers';
import { getQuery } from 'Core/data/Helpers';
import { optionsTimeFrame } from 'Core/defaultValues';
import { isArray } from 'lodash';

const ActivityLogs = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();
    let optionsTime = optionsTimeFrame();

    const activities = useSelector(state => state.activitiesMainRedux.activities);
    const accounts = useSelector(state => state.activitiesMainRedux.accounts);
    const loadingAccounts = useSelector(state => state.activitiesMainRedux.loadingAccounts);
    const nextToken = useSelector(state => state.activitiesMainRedux.nextToken);
    const loadingActivities = useSelector(state => state.activitiesMainRedux.loadingActivities);
    const users = useSelector(state => state.activitiesMainRedux.users);
    const lang = useSelector(state => state.commonRedux.language);

    //Local States
    const [startDate, setStartDate] = useState(moment().day(0).startOf('day').toDate());
    const [endDate, setEndDate] = useState(moment.max(moment()).toDate());

    const [search, setSearch] = useState(null);

    const [account, setAccount] = useState(null);
    const [username, setUsername] = useState(null);
    const [timeFrame, setTimeFrame] = useState(optionsTime[2])
    const [actions, setActions] = useState([]);
    const [conditions, setConditions] = useState(null);

    const [columns, setColumns] = useState([
        {
            key: "username",
            title: messages['activities_main_username'],
            width: 150,
            show: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return row?.username',
            code: "activities_main_username",
            render: (item) => {
                return <span>{item.username}</span>
            }
        },
        {
            key: "controller",
            title: messages['activities_main_controller'],
            width: 150,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.module',
            code: "activities_main_controller",
            render: (item) => {
                return <span>{item.module}</span>
            }
        },
        {
            key: "action",
            title: messages['activities_main_action'],
            width: 150,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: `
                let lang = "${lang}";
                const translations = {
                    en: {
                        insert: "Insert",
                        update: "Update",
                        delete: "Delete",
                        other: "Other"
                    },
                    es: {
                        insert: "Agregar",
                        update: "Editar",
                        delete: "Eliminar",
                        other: "Otros"
                    }
                };
                return translations[lang][row.action] || row.action;
            `,
            code: "activities_main_action",
            render: (item) => {
                return <span>{messages[item?.action] || item?.action}</span>
            }
        },
        {
            key: "date_and_time",
            title: messages['activities_main_date_time'],
            width: 250,
            show: true,
            resize: true,
            export: true,
            functionString: `
                function formatDate(date) {
                    let dateToformat = moment(date)
                    let formatted = moment(dateToformat).tz(timezone).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }
                let timezone = "${account?.timezone}"
                return row?.updatedOn ? formatDate(row?.updatedOn, timezone) : ''
            `,
            code: "activities_main_date_time",
            render: (item) => {
                return <span>{item.updatedOn && getDateFormatted(item.updatedOn, "date", "datetime", null, account?.timezone)}</span>
            }
        },
        {
            key: "source",
            title: messages['activities_main_source'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.source',
            code: "activities_main_source",
            render: (item) => {
                return <span>{item.source}</span>
            }
        },
        {
            key: "url",
            title: messages['activities_main_url'],
            width: 350,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.urlReferrer',
            code: "activities_main_url",
            render: (item) => {
                return <span>{item.urlReferrer}</span>
            }
        },
        {
            key: "method",
            title: messages['activities_main_method'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.method',
            code: "activities_main_method",
            render: (item) => {
                return <span>{item.method}</span>
            }
        },
        {
            key: "Ip_Address",
            title: messages['activities_main_ip_address'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.ipAddress',
            code: "activities_main_ip_address",
            render: (item) => {
                return <span>{item.ipAddress}</span>
            }
        },
        {
            key: "platform",
            title: messages['activities_main_platforms'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.platform',
            code: "activities_main_platforms",
            render: (item) => {
                return <span>{item.platform}</span>
            }
        },
        {
            key: "EntityName",
            title: messages['activities_main_entity_name'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.entityName',
            code: "activities_main_entity_name",
            render: (item) => {
                return <span>{item.entityName}</span>
            }
        },
        {
            key: "EntityID",
            title: messages['activities_main_entity_id'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.entityId',
            code: "activities_main_entity_id",
            render: (item) => {
                return <span>{item.entityId}</span>
            }
        },
        {
            key: "Parameters",
            title: messages['activities_main_parameters'],
            width: 250,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.parameters',
            code: "activities_main_parameters",
            render: (item) => {
                return (<div>{item.parameters}</div>)
            }
        },
        {
            key: "newvalues",
            title: messages['activities_main_new_values'],
            width: 300,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.newValues',
            code: "activities_main_new_values",
            render: (item) => {
                return (
                    <div>{item.newValues}</div>
                )
            }
        },
    ]);

    const applyFilters = (openSearch, refresh) => {
        if (openSearch) {
            setSearch(openSearch || null);
        }
        if (refresh) {
            dispatch(clearRedux("ACTIVITIES_MAIN", { nextToken: null, activities: [] }));
        }
        if (account?.id) {
            let action = actions?.length > 0 ? actions.map((item) => (item.value)) : ["insert", "update", "delete", "other"]
            let currentOpenSearch = !search && !openSearch ? [] : isArray(openSearch) ? openSearch : [search]
            let payload = {
                accountId: account?.id,
                dateRange: {
                    start: startDate,
                    end: endDate,
                },
                action,
                opensearch: currentOpenSearch,
                username: username?.userName || ''
            }
            if (nextToken && !openSearch && !refresh) payload.nextToken = nextToken
            !nextToken && dispatch(clearRedux("ACTIVITIES_MAIN", { activities: [] }))
            setConditions(payload);
            dispatch(activitiesSearchActivitiesLogsRequest(payload));

        } else {
            NotificationManager.error(messages['activities_main_error_message'], messages['activities_main_apply_filters'], 3000, null, null, '', null);
        }
    }

    const handleTimeFrame = (type) => {
        setTimeFrame(type);
        const { start, end } = getTimeFrame(type.Id);
        setStartDate(start);
        setEndDate(end);
    }

    const accountHandler = (newaccount) => {
        if (newaccount?.id) dispatch(activitiesSearchUsersRequest(newaccount.id))
        else dispatch(clearRedux("ACTIVITIES_MAIN", { users: [] }))
        setAccount(newaccount)
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (search || search === "") {
            const timer = setTimeout(() => {
                applyFilters(search, true);
            }, 700)
            return () => clearTimeout(timer);
        }
    }, [search])

    useEffect(() => {
        dispatch(clearRedux("ACTIVITIES_MAIN", { nextToken: null, activities: [] }));
    }, [])

    useEffect(() => {
        if (account && account?.timezone) {
            let currentColumns = columns.map((item) => ({
                ...item,
                functionString: item.key === "date_and_time" ? `
                    function formatDate(date,tz) {
                        let dateToformat = moment(date)
                        let formatted = moment(dateToformat).tz(tz).format("YYYY/MM/DD HH:mm:ss")
                        return formatted;
                    }
                    let timezone = "${account.timezone}"
                    return row?.updatedOn ? formatDate(row?.updatedOn, timezone) : ''
                `: item.functionString
            }))
            setColumns(currentColumns)
        }
    }, [account])

    return (
        <Container maxWidth={false} className="container-view activities-container">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Typography variant="h5" gutterBottom component="div">
                        {messages['activities_main_user_activity_logs']}
                    </Typography>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <Grid
                        container
                        direction="row"
                        spacing={2}
                    >
                        <Grid item xs={2}>
                            <CustomSelect
                                async
                                value={account}
                                onChange={(items) => accountHandler(items)}
                                label={messages['activities_main_account']}
                                loadOptions={getAccountsForSelect}
                                loading={loadingAccounts}
                                required
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                                className="account-select-activities-log"
                                placeholder={messages['select']}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Select
                                className="filters-activity-logs"
                                id="username"
                                label={messages['activities_main_username']}
                                options={users || []}
                                value={username}
                                textField="userName"
                                valueField="id"
                                onChange={setUsername}
                                isClearable
                                placeholder={messages['select']}
                            />
                        </Grid>
                        <Grid item xs={4} className="actions-audit-logs">
                            <CustomSelect
                                options={getAuditLogsActions(messages) || []}
                                value={actions}
                                isMulti
                                label={messages['activities_main_actions']}
                                onChange={(e) => setActions(e)}
                                placeholder={messages['select']}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Select
                                isMulti
                                className="filters-activity-logs"
                                id="timeframe"
                                label={messages['activities_main_time_frame']}
                                options={optionsTime}
                                value={timeFrame}
                                textField="Nametag"
                                valueField="Id"
                                onChange={(items = []) => handleTimeFrame(items)}
                                placeholder={messages['select']}
                            />
                        </Grid>
                        <Grid item xs={2} >
                            <div className="filters-apply" style={{ marginTop: 25, width: '100%' }}>
                                <Button
                                    style={{ width: '100%' }}
                                    className="btn-dark-blue"
                                    onClick={() => applyFilters(null, true)}
                                >
                                    {messages['activities_main_apply']}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        ref={tableRef}
                        exportName="useractivitylogs"
                        name="pm-activities-list"
                        noFilters
                        entity="user-activity-logs"
                        externalData={activities}
                        externalLoading={loadingActivities}
                        disableItemSelection
                        externalRefresh={() => {
                            applyFilters(null, true)
                        }
                        }
                        query={getQuery("user-activitys-logs")}
                        customQuery="id name"
                        onChangeConditions={(tags, conditions, total, newColumns) => {
                            if (tags && account) {
                                let labelsOpenSearch = tags.map(tag => tag.undefined);
                                applyFilters(labelsOpenSearch, true);
                            }
                        }}
                        isDynamo
                        noSearchOptions
                        conditions={conditions}
                        columns={columns}
                        topheight={250}
                        noSplit
                        hideAllInPagination
                        infiniteScroll
                        nextToken={nextToken}
                        onChangePage={() => {
                            applyFilters()
                        }}
                        onChangeSearch={(value) => setSearch(value)}
                        tableButtons={["export", 'orderColumn']}
                        onChangeColumns={(items) => {
                            let currentColumns = items.map((item) => ({
                                ...item,
                                title: item.code ? messages[item.code] : item.title,
                                render: item.key === "action" ? (item) => {
                                    return (<span>{messages[item?.action] || item?.action}</span>)
                                } : item.render,
                                functionString: item.key === "action" ? `
                                let lang = "${lang}";
                                const translations = {
                                    en: {
                                        insert: "Insert",
                                        update: "Update",
                                        delete: "Delete",
                                        other: "Other"
                                    },
                                    es: {
                                        insert: "Agregar",
                                        update: "Editar",
                                        delete: "Eliminar",
                                        other: "Otros"
                                    }
                                };
                                return translations[lang][row.action] || row.action;
                                `: item.functionString
                            }))
                            setColumns(currentColumns)
                        }}
                        noTags
                        noPDF
                        placeholderSearch={messages['activities_main_search_controller']}
                        noSearch
                        simpleSearch
                    />
                </Grid>
            </Paper>
        </Container>
    )
}
export default ActivityLogs;

